import { Languages as OrganizationUserLanguages } from '@generated/graphql';
import { Languages } from '@onevesthq/ov-enums';

export const organizationUserLanguageByLanguage: {
  [K in Languages]: OrganizationUserLanguages;
} = {
  [Languages.ENGLISH]: OrganizationUserLanguages.English,
  [Languages.FRENCH]: OrganizationUserLanguages.French,
  [Languages.SPANISH]: OrganizationUserLanguages.Spanish,
};

export const languageByOrganizationUserLanguage: {
  [K in OrganizationUserLanguages]: Languages;
} = {
  [OrganizationUserLanguages.English]: Languages.ENGLISH,
  [OrganizationUserLanguages.French]: Languages.FRENCH,
  [OrganizationUserLanguages.Spanish]: Languages.SPANISH,
};
